var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("\n      QMKey 4.0.0-a1\n      "),_c('em',[_vm._v("Peppa Pig")])])])
}]

export { render, staticRenderFns }